import styled from '@emotion/styled';
import { useRef } from 'react';
import { useButton } from 'react-aria';

import { Glyph } from '../../common/Glyph';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import glyphStyles from '../../common/Glyph.module.css';

export function BackButton(props) {
  const ref = useRef();
  const button = useButton(props, ref);

  return (
    <BackButton.Root {...button.buttonProps} ref={ref}>
      <Glyph
        color={theme.icon.color_body_light}
        size={theme.icon.size_default}
        source={glyph.core.arrowLeft}
        mirrorRTL={true}
      />
      {props.children}
    </BackButton.Root>
  );
}

BackButton.Root = styled.button`
  padding: ${su(1, 0)};
  color: ${theme.color.text_light};

  .${glyphStyles.root} {
    margin-inline-end: ${su(1)};
  }

  &:hover {
    color: ${theme.color.text_light_hover};

    .${glyphStyles.root} {
      color: ${theme.icon.color_body_light_hover};
    }
  }
`;
